import { render, staticRenderFns } from "./PickUpTimeUpdate.vue?vue&type=template&id=351d33cc&scoped=true&"
import script from "./PickUpTimeUpdate.vue?vue&type=script&lang=js&"
export * from "./PickUpTimeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PickUpTimeUpdate.vue?vue&type=style&index=0&id=351d33cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d33cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
